import { Box, ListItemButton, ListItemText } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';
import { radius } from '@karehero/llama/theme/radius';

/**
 * A row in a list of conversations: a small icon right beside the words, so
 * every row starts on the same left edge. The plus for a new one, in Marine
 * Green; a message for one that exists, quieter. Put inside a List.
 */
const ConversationRow = ({
  label,
  isNew = false,
  tile = false,
  onClick,
}: {
  label: string;
  /** The New conversation row: a plus, in the brand colour. */
  isNew?: boolean;
  /**
   * The icon in a rounded square of its own, for a list on a page rather
   * than in the drawer: bigger, so each row reads as a thing.
   */
  tile?: boolean;
  onClick: () => void;
}) => (
  <ListItemButton
    onClick={onClick}
    // On a page the tile lines up with the heading above it, so no side
    // padding of its own.
    sx={{ gap: tile ? 2 : 1, ...(tile && { px: 0 }) }}
  >
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        color: isNew
          ? 'primary.main'
          : tile
            ? 'text.primary'
            : 'text.secondary',
        ...(tile && {
          width: 44,
          height: 44,
          flexShrink: 0,
          border: 1,
          borderColor: 'custom.neutral.200',
          borderRadius: `${radius.md}px`,
          bgcolor: 'background.paper',
        }),
      }}
    >
      <Icon icon={isNew ? 'plus' : 'message'} fontSize={tile ? 18 : 14} />
    </Box>
    <ListItemText
      primary={label}
      slotProps={
        tile
          ? // subtitle1 brings grey of its own, so charcoal is set here.
            { primary: { variant: 'subtitle1', sx: { color: 'text.primary' } } }
          : undefined
      }
    />
  </ListItemButton>
);

export default ConversationRow;
